import { AnchorHTMLAttributes, DetailedHTMLProps, HTMLAttributes } from 'react';

type Props = {
  tag?: React.ElementType;
  skip?: boolean;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

const SkipTranslationWrapper = ({ tag: Tag = 'div', children, skip = true, ...props }: Props) => {
  return (
    <Tag
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      translate={skip ? 'no' : undefined}
      notranslate={skip ? 'true' : undefined}
    >
      {children}
    </Tag>
  );
};

export default SkipTranslationWrapper;
